<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center py-2">
        <div class="ms-auto">
          <router-link to="special-category/0">
            <button class="btn btn-primary me-2 mb-2"><i class="uil uil-plus me-1"></i>Add Special Category</button>
          </router-link>
          <button class="btn btn-secondary mb-2" @click="getSpecialCategories()">
            <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
          </button>
        </div>
      </div>

      <div class="row p-2">
        <div class="col-md-4 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Search Keyword">
              <form class="d-flex" @submit.prevent="">
                <b-form-group id="input-group-3" label-for="search-field">
                  <b-form-select
                    class="form-select rounded-0 rounded-start shadow-none"
                    id="search-field"
                    style="width: fit-content"
                    v-model="search.field"
                    :options="searchFieldOptions"
                  ></b-form-select>
                </b-form-group>

                <b-input-group>
                  <b-form-input class="rounded-0 rounded-end" v-model="search.keyword" @keyup.enter="getSpecialCategories()"></b-form-input>
                </b-input-group>
              </form>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by Status">
              <b-form-select
                class="form-select rounded shadow-none dd-custom-size"
                v-model="search.status"
                :options="statusOptions"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by date added" class="me-2 w-daterange">
              <flat-pickr
                v-model="search.dateRange"
                :config="rangeOptions"
                placeholder="Select a date range"
                class="form-control"
              ></flat-pickr>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-1 col-sm-3 p-0 me-2 mb-2">
          <b-button
            variant="primary"
            class="h-fit d-flex align-items-center justify-content-center me-2 w-100"
            @click="getSpecialCategories()"
          >
            <i class="bx bx-search me-1 mt-1"></i>Search
          </b-button>
        </div>

        <!-- <div class="col-md-1 col-sm-6 p-0">
          <b-button
            variant="primary"
            class="h-fit me-2 d-flex align-items-center justify-content-center w-100"
            @click="
              isSearching = true;
              onExport();
            "
          >
            <i class="uil uil-export me-1"></i>
            Export
          </b-button>
        </div> -->
      </div>

      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="specialCategoryList"
            :fields="fields"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="orderBy"
            :sort-desc.sync="sortDesc"
            :filter-included-fields="filterOn"
            class="table-check"
            @sort-changed="sortCategory"
          >
            <template #cell(action)="data">
              <div class="d-flex">
                <b-button id="show-btn" class="btn btn-sm btn-danger" @click="deleteItem(data.item)"
                  ><i class="bx bx-trash bx-xs bx-fw"></i
                ></b-button>
              </div>
            </template>
            <template #cell(special_category_name)="data">
              <div>
                <router-link :to="`special-category/${data.item.id}`">
                  {{ data.item.special_category_name }}
                </router-link>
              </div>
            </template>
            <template #cell(icon)="data" >
              <img class="icon-style" :src="setIconSrc(data.item.icon)" alt="">
            </template>
            <template #cell(color)="data">
              <div :style="setColorStyle(data.item.color)"></div>
            </template>
            <template #cell(item_count)="data">
              {{ data.item.item_count }}
            </template>
            <template #cell(status)="data">
              <div :class="{ 'text-success': data.item.status == 1, 'text-danger': data.item.status == 0 }">
                {{ data.item.status == 1 ? "Active" : "Disabled" }}
              </div>
            </template>
            <template #cell(hierarchy)="data">
              <div :class="{
                'text-success': data.item.status == 1,
                'text-danger': data.item.status == 0
              }">
                {{ data.item.hierarchy }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, digitalLoadMethods, digitalLoadComputed } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";

export default {
  page: {
    title: "eLoad Special Category",
  },
  data() {
    return {
      // totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      orderBy: "sc.hierarchy",
      sort: "ASC",
      sortDesc: false,
      submitted: false,
      search: {
        keyword: "",
        field: null,
        status: "",
        dateRange: null,
      },
      isSearching: false,
      specialCategoryList: [],
      updatedCategoryList: [],
      fields: [
        { key: "action", sortable: false, tdClass: "align-middle" },
        { key: "special_category_name", label: "Special Category Name", sortable: false, tdClass: "align-middle" },
        { key: "icon", sortable: false, tdClass: "align-middle" },
        { key: "color", sortable: false, tdClass: "align-middle" },
        { key: "item_count", sortable: false, tdClass: "align-middle" },
        { key: "status", sortable: false, tdClass: "align-middle" },
        { key: "hierarchy", sortable: false, tdClass: "align-middle" },
      ],

      rangeOptions: {
        mode: "range",
      },

      searchFieldOptions: [
        { text: "Search All", value: null },
        { text: "Category Name", value: "sc.special_category_name" },
      ],

      statusOptions: [
        { text: "All", value: "" },
        { text: "Active", value: 1 },
        { text: "Disabled", value: 0 },
      ],
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...digitalLoadComputed,
  },
  methods: {
    ...layoutMethods,
    ...digitalLoadMethods,
    async getSpecialCategories() {
      let params = {
        // rows: this.isSearching ? 1 : this.perPage,
        page: this.isSearching ? 1 : this.currentPage,
        orderBy: this.orderBy,
        sort: this.sort,
        search: this.search,
      };

      await this.getLoadSpecialCategoryList(params).then(() => {
        this.specialCategoryList = JSON.parse(JSON.stringify(this.loadSpecialCategoryList));
      });
    },

    async sortCategory() {},
    async deleteItem(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete ${item.special_category_name}? This process cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "##804997",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.actionSpecialCategory({ action: "delete", id: item.id })
            .then(async () => {
              Swal.fire("Delete Successful!", `${item.special_category_name} has been deleted.`, "success");
              await this.getSpecialCategories();
            })
            .catch((error) => {
              Swal.fire("Delete Failed!", `An error occured while deleting ${item.special_category_name}: ${error.data.message}`, "error");
            });
        }
      });
    },
    addCategoryToList(item) {
      this.updatedCategoryList.push(item)
    },
    checkIfHierarchyIsTaken(item) {
      let isTaken =
        this.specialCategoryList.some((i) => i.hierarchy == item.hierarchy && i.id != item.id) ||
        item.hierarchy == "" ||
        item.hierarchy == null;
      return isTaken;
    },
    async onUpdateHierarchy(item) {
      // if (item.hierarchy == "" || item.hierarchy == null || (await this.checkIfHierarchyIsTaken(item))) {
      //   return;
      // }
      item.name = item.special_category_name;
      delete item.special_category_name;
      await this.actionSpecialCategory({
        action: "update",
        ...item,
      })
        .then(async () => {
          // Swal.fire("Successfully Updated!", `${item.name} has been updated.`, "success");
          await this.getSpecialCategories();
        })
        .catch(() => {
          Swal.fire("Updated Failed!", "An error occured while updating hierarchy", "error");
        });
    },
    setIconSrc(icons) {
      return icons.find(icon => icon.default).url
    },
    setColorStyle(colors) {
      let colorSrc = colors.find(color => color.default).value
      let style = `background-color: ${colorSrc}; height: 20px; width: 20px; border-radius: 50%;`
      return style
    },
  },
  async mounted() {
    this.changeTitle({ title: "eLoad Special Category" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Digital Load", to: { name: "" } },
        { text: "Special Category Promo", to: { name: "" } },
      ],
    });

    await this.getSpecialCategories();
  },
};
</script>

<style scoped>
.icon-style {
  max-height: 50px;
  max-width: 50px;
}
</style>
